// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  config: 'appsettings.json',
  // apiUrl: 'http://localhost:5010/',
  // imageUrl: 'http://localhost:5010/Files/',
  // apiUrl: 'https://app.alias-solutions.net:5010/',
  // imageUrl: 'https://app.alias-solutions.net:5010/Files/',
  apiUrl: 'https://app.alias-solutions.net:5011/',
  imageUrl: 'https://app.alias-solutions.net:5011/Files/',
  apiUrls: 'https://api-fsp.paynowafrica.com/',
};

export const config = {
//   apiUrl: 'https://soft.acyst.tech/',
//   ordUrl: 'https://soft.acyst.tech/orders',
//   imageUrl: 'https://soft.acyst.tech/Files/'
};

// export const config = {
//   apiUrl: 'http://192.168.0.158:5002/',
//   imageUrl: 'http://192.168.0.158:5002/Files/'
// };    

// export const config = {
//   apiUrl: 'http://localhost:5001/',
//    imageUrl: 'http://localhost:5001/Files/'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
